import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { renderToString } from 'react-dom/server';
import Loader from 'components/loader/loader';
import RichTextViewer from 'components/rich-text-viewer/rich-text-viewer';
import { t } from 'i18next';
import FilesComponent from 'components/files/files';
const QuestionFillBlanks = ({ content, blanks, initialState, instructionsFile, getLocalAnswers }) => {
    const [frameRef, setFrameRef] = useState();
    const [answers, setAnswers] = useState([]);
    const [localAnswers, _setLocalAnswers] = useState([]);
    const answersRef = useRef(localAnswers);
    const [preparedContent, setPreparedContent] = useState();
    const [listenerMapped, setListenerMapped] = useState(false);
    useEffect(() => {
        if (answers.length === 0) {
            return;
        }
        const sameLength = answers.length === (initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer.length);
        const sameAsInitialState = initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer.every((item) => {
            const exists = answers.find(answer => answer.id === item.id);
            if (!exists) {
                return false;
            }
            if (exists.answer === item.answer) {
                return true;
            }
            return false;
        });
        /**Checks if the answers are the same as Initial State */
        if (sameLength && sameAsInitialState) {
            return;
        }
        getLocalAnswers(answers);
    }, [answers]);
    useEffect(() => {
        if (!localAnswers) {
            return;
        }
        setAnswers(localAnswers);
    }, [localAnswers]);
    useEffect(() => {
        const initialAnswers = initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer;
        if (initialAnswers) {
            setLocalAnswers(initialAnswers);
        }
        let alteredContent = content;
        const inputs = [];
        blanks.forEach(blank => {
            var _a, _b, _c, _d, _e;
            const answered = (initialAnswers !== null && initialAnswers !== void 0 ? initialAnswers : []).find(item => item.id === blank.id);
            const blankPiece = `%BLANK_${blank.id}%`;
            let blankInput = '';
            if (blank.type === 'text') {
                const input = (_jsx("input", { className: 'input--fill-in-blank', type: 'text', id: `blank_${blank.id}`, defaultValue: (_a = answered === null || answered === void 0 ? void 0 : answered.answer) !== null && _a !== void 0 ? _a : '' }, `blank_${blank.id}`));
                blankInput = renderToString(input);
            }
            if (blank.type === 'select') {
                const shuffleOptions = shuffle((_b = blank.options) !== null && _b !== void 0 ? _b : []);
                const input = (_jsxs("select", Object.assign({ className: 'select--fill-in-blank', id: `blank_${blank.id}`, defaultValue: (_c = answered === null || answered === void 0 ? void 0 : answered.answer) !== null && _c !== void 0 ? _c : '' }, { children: [_jsx("option", Object.assign({ value: '' }, { children: t('TAKE_EXAM.FILL_BLANKS_SELECT') }), void 0), shuffleOptions.map((option, index) => (_jsx("option", Object.assign({ value: option }, { children: option }), index)))] }), `blank_${blank.id}`));
                blankInput = renderToString(input);
            }
            if (((_d = blank === null || blank === void 0 ? void 0 : blank.closingTags) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                blankInput = `${blank.closingTags.join('')} ${blankInput}`;
            }
            if (((_e = blank === null || blank === void 0 ? void 0 : blank.openingTags) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                blankInput = `${blankInput} ${blank.openingTags.join('')}`;
            }
            inputs.push({
                text: blankPiece,
                input: blankInput
            });
        });
        inputs.forEach(input => {
            alteredContent = alteredContent.replace(input.text, input.input);
        });
        setPreparedContent(alteredContent);
    }, [content]);
    useEffect(() => {
        if (!preparedContent || !frameRef) {
            return;
        }
        const iFrameDocument = frameRef.contentDocument;
        if (!iFrameDocument) {
            return;
        }
        const inputs = iFrameDocument.querySelectorAll('input');
        const selectors = iFrameDocument.querySelectorAll('select');
        if ((!inputs || inputs.length === 0) && (!selectors || selectors.length === 0)) {
            return;
        }
        mapListeners([...inputs, ...selectors]);
    }, [preparedContent, frameRef]);
    const shuffle = array => {
        let currentIndex = array.length;
        let randomIndex;
        // While there remain elements to shuffle...
        while (currentIndex != 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
        return array;
    };
    const setLocalAnswers = (data) => {
        answersRef.current = data;
        _setLocalAnswers(data);
    };
    const mapListeners = (inputs) => {
        if (!inputs) {
            return;
        }
        const listeners = [];
        inputs.forEach((input) => {
            if (!input.id.includes('blank')) {
                return;
            }
            input.oninput = () => {
                handleBlank(Number(input.id.split('_')[1]), input.value);
            };
            listeners.push({
                id: Number(input.id.split('_')[1]),
                answer: input.value
            });
        });
        setListenerMapped(true);
    };
    const handleBlank = (id, answer) => {
        const newAnswer = { id, answer };
        const exists = answersRef.current.find(item => item.id === id);
        if (!exists || answersRef.current.length === 0) {
            setLocalAnswers([...answersRef.current, newAnswer]);
            return;
        }
        const edited = answersRef.current.map(item => {
            if (item.id !== id) {
                return item;
            }
            return Object.assign(Object.assign({}, item), { answer });
        });
        setLocalAnswers(edited);
    };
    const iFrameInitialContent = `
    <!DOCTYPE html>
    <html>
      <head>
      <link type="text/css" rel="stylesheet" href="https://cdn.tiny.cloud/1/kdsi0dycn4pq62nxenf4zbb3iqayj68ly6zxpt7czz5lb33p/tinymce/6.1.2-8/skins/ui/oxide/content.min.css" crossorigin="anonymous">
      <link type="text/css" rel="stylesheet" href="https://cdn.tiny.cloud/1/kdsi0dycn4pq62nxenf4zbb3iqayj68ly6zxpt7czz5lb33p/tinymce/6.1.2-8/skins/content/default/content.min.css" crossorigin="anonymous">
      <base target="_blank">
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;400;500;600;700;800&display=swap');

        .preview__text {
          display: block;
          background: #f6f8ff;
          padding: 32px;
          line-height: 2.5;
          margin: 16px 0px 40px;
          text-align: justify !important;
        }

        .input--fill-in-blank, .select--fill-in-blank {
          display: inline;
          min-width: 100px;
          width: 100px;
          height: 27px;
          margin: 0px;
          border: none;
          color: #1b1c23;
          border-bottom: 2px dashed #1b1c23;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          font-family: "Montserrat", serif;
        }
        
        .select--fill-in-blank {
          padding: 0px 16px;
          height: 32px;
          width: auto;
        }
      </style>
      </head>
      <body id="tinymce" class="mce-content-body">
        <div id="mountTarget" class="preview__text"></div>
      </body>
    </html>
  `;
    return (_jsxs("div", Object.assign({ className: 'blank-question' }, { children: [(!preparedContent || !listenerMapped) && (_jsx(Loader, {}, void 0)), preparedContent !== undefined && (_jsx(RichTextViewer, { id: 'fill-blanks-content', content: preparedContent, customInitialContent: iFrameInitialContent, getFrameRef: (e) => setFrameRef(e) }, void 0)), instructionsFile && (_jsx(FilesComponent, { file: instructionsFile }, void 0))] }), void 0));
};
export default QuestionFillBlanks;
